
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/rapid-mag-power-bank",
      function () {
        return require("private-next-pages/rapid-mag-power-bank/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/rapid-mag-power-bank"])
      });
    }
  